import { render } from "./BackGround.vue?vue&type=template&id=4303cf5c&scoped=true"
import script from "./BackGround.vue?vue&type=script&lang=js"
export * from "./BackGround.vue?vue&type=script&lang=js"

import "./BackGround.vue?vue&type=style&index=0&id=4303cf5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4303cf5c"]])

export default __exports__